<template>
  <TheModal class="modal-enter profile-modal" v-model:show="showModal">
    <div class="enter__body modal__body center">
      <div class="modal__close center" @click="setShowProfileModal(false)">
        <KpIcon name="close" class="close" />
      </div>

      <ProfileForm/>
    </div>
  </TheModal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import cookieStorage from "@/plugins/cookieStorage.js"

import TheModal from '@/components/TheModal.vue'
import ProfileForm from '@/components/form/ProfileForm.vue'

import { COOKIE_NAMES } from '@/configs/constants'

export default {
  name: 'KpProfileModal',

  components: { ProfileForm, TheModal },

  computed: {
    ...mapGetters('profileModal', ['isShowProfileModal']),

    showModal: {
      get() {
        return this.isShowProfileModal && !cookieStorage.getItem(COOKIE_NAMES.pauseProfileModalWindow)
      },

      set(value) {
        this.setShowProfileModal(value)
      }
    }
  },
  methods: {
    ...mapActions('profileModal', ['setShowProfileModal'])
  },
}
</script>

<style lang="scss" scoped>
.profile-modal {
  .enter__body {
    max-height: 90%;
    width: 528px;
    display: flex;
    flex-direction: column;

    .profile-form {
      flex-grow: 1;
      overflow-y: auto;
    }

    @media (max-width: 650px) {
      max-height: 80%;
      width: 100%;
    }

    svg.close {
      width: 32px;
      height: 32px;

      :deep(path) {
        stroke: #ffffff;
      }
    }
  }
}
</style>